import { DateTime } from 'luxon';

import { Ref } from '@/decorators/ref';
import constants from '@/helpers/constants';
import { assignOwnProperties } from '@/utils/assignOwnProperties';
import type { IAttachmentInfo } from '~/api/IAttachmentInfo';

export class Attachment implements IAttachmentInfo {
  @Ref filename: string;
  @Ref comment?: string;
  @Ref blobKey: string;
  @Ref id: string;
  @Ref attachmentID: number;
  @Ref createdDate: string;
  @Ref location: string;
  @Ref who: string;
  @Ref userKey: string;
  @Ref status: number;

  constructor(data: Partial<IAttachmentInfo>) {
    assignOwnProperties(this, data);
  }

  get attachmentId(): string {
    return this.attachmentID?.toString() || '';
  }

  get extension(): string {
    const lastDotIndex = this.filename.lastIndexOf('.');
    return lastDotIndex !== -1 ? this.filename.slice(lastDotIndex + 1).toLowerCase() : '';
  }

  get displayName(): string {
    // Remove GUID prefix if present (format: GUID_filename)
    const underscoreIndex = this.filename.indexOf('_');
    if (underscoreIndex > 0 && underscoreIndex === 36) { // GUID is 36 chars
      return this.filename.substring(underscoreIndex + 1);
    }
    return this.filename;
  }

  get formattedCreatedDate(): string {
    return DateTime.fromISO(this.createdDate, { zone: 'utc' })
      .toLocal().toFormat(constants.FORMATS.DATE_TIME_SHORT_24_WITH_SECONDS);
  }

  get isActive(): boolean {
    return this.status === 1;
  }
}
